<template>
  <b-row style="width: 100%">
    <gallery
      :images="gallPhotos"
      :index="gallIndex"
      @close="index = null, $emit('disableEsc', false)"
    />
    <b-col>
      <div
        class="py-3 pl-3"
        v-for="(name, nameIndex) in $store.getters.galleryPhotos"
        :key="nameIndex"
      >
        <div class="galleryFrame">
          <b class="mx-4">{{$store.getters.galleryPhotos[nameIndex].name}}</b>
          <b-row>
            <div
              class="m-2 p-2 pl-4 mx-2"
              v-for="(photo, photoIndex) in $store.getters.galleryPhotos[nameIndex].photos"
              :key="photoIndex"
            >
              <div class="cBody" :style="`width: ${14}rem; height: ${14}rem;`">
                <div class="cPhoto m-1">
                  <div @click="$emit('disableEsc', true), loadImgViewer(nameIndex,photoIndex)">
                    <b-img-lazy
                      class="cImg"
                      :src="`${$store.getters.galleryPhotos[nameIndex].photos[photoIndex]}?type=preview`"
                    />
                  </div>
                </div>
                <b-button
                  v-if="showDeleteBtn"
                  @click="deleteDialog($store.getters.galleryPhotos[nameIndex].photos[photoIndex])"
                  class="cBtn m-2"
                  variant="danger"
                >X</b-button>
              </div>
            </div>
          </b-row>
        </div>
      </div>
    </b-col>
    <b-modal ref="confirmDelete" title="Skutečne smazat??">
      <template slot="modal-footer">
        <b-button size="sm" variant="danger" @click="deletePhoto()">Smazat</b-button>
        <b-button size="sm" variant="success" @click="$refs['confirmDelete'].hide()">Zrušit</b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueGallery from 'vue-gallery'

export default Vue.extend({
  props: {
    peopleDetail: {},
    showDeleteBtn: null
  },
  components: {
    gallery: VueGallery
  },
  data: () => ({
    file: null,
    peopleID: null,
    gallPhotos: null,
    gallIndex: null,
    photoForDelete: null
  }),
  mounted () {
    // TODO potencialne nestabilne - vymysliet lepsie riesenie
    if (this.$route.params.id !== undefined) {
      this.peopleID = this.$route.params.id
    } else {
      this.peopleID = this.peopleDetail.id
    }

    axios
      .get(`/api/v1/people/${this.peopleID}/photo`)
      .then(response => {
        let peopleID = this.peopleID
        response.data.forEach(function (photoFolder) {
          let photos = []
          photoFolder.photos.forEach((photo) => {
            photos.push(`/api/v1/people/${peopleID}/photo/${photoFolder.name}/${photo}`)
          })
          photoFolder.photos = photos
        })
        this.$store.commit('galleryPhotos', response.data)
      })
  },
  methods: {
    deleteDialog (photo) {
      this.$refs['confirmDelete'].show()
      this.photoForDelete = photo
    },
    loadImgViewer (nameIndex, photoIndex) {
      this.gallPhotos = this.$store.getters.galleryPhotos[nameIndex].photos
      this.gallIndex = photoIndex
    },
    deletePhoto () {
      axios
        .delete(this.photoForDelete)
        .then(response => {
          this.photoForDelete = null
          axios
            .get(`/api/v1/people/${this.peopleID}/photo`)
            .then(response => {
              let peopleID = this.peopleID

              response.data.forEach(function (photoFolder) {
                let photos = []
                photoFolder.photos.forEach((photo) => {
                  photos.push(`/api/v1/people/${peopleID}/photo/${photoFolder.name}/${photo}`)
                })
                photoFolder.photos = photos
              })
              this.$store.commit('galleryPhotos', response.data)
            })
          this.$refs['confirmDelete'].hide()
        })
        .catch(response => {
          console.log(response.data)
        })
    }
  }

})
</script>

<style scoped>
.galleryFrame {
  background-color: rgba(235, 253, 255, 0.4);
  border: 1px solid rgba(133, 116, 116, 0.3);
  border-radius: 10px;
  box-shadow: 2px 2px 0.4em 0 rgb(210, 210, 210);
  display: flex;
  flex-direction: column;
}

.cBody {
  position: relative;
  background-color: white;
  border: 0px solid rgb(133, 116, 116);
  border-radius: 5px;
  box-shadow: 10px 10px 0.4em 0 rgb(210, 210, 210);
  display: flex;
  flex-direction: column;
}

.cPhoto {
  display: flex;
  flex: 1;
  min-height: 0;
  background-image: radial-gradient(
    rgb(220, 220, 220) 30%,
    rgb(255, 255, 255) 75%
  );
}

.cImg {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.cText {
  height: 1.4em;
  overflow: hidden;
}

.cBtn {
  border-radius: 20px;
  position: absolute;
  bottom: 0;
}
</style>
